import { Loading } from "@servahealth/serva-ui-kit";
import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import blank from '../../images/blank.png';
import useAuth from "../../Hooks/useAuth";

/**
 * Handle logout by clearing refresh token and redirecting to loginredirect
 */
const Logout = () => {
    const [params] = useSearchParams();
    const redirect_uri = params.get('redirect_uri');
    const nav = useNavigate();
    const { clearRefreshToken } = useAuth();
	const effectRan = useRef<boolean>(false);
    
    useEffect(() => {
        if (!effectRan.current) {
            clearRefreshToken();
            if (!!redirect_uri)
                window.location.href = redirect_uri;
            else
                nav('/landing?reason=It looks like you were logged out of one of Serva Health\'s apps. You may close this tab when you\'re done.');
        }

        return () => { effectRan.current = true };
    }, [clearRefreshToken, nav, redirect_uri]);

    return <Loading logoSrc={blank} />
};

export default Logout;